var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshCw({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh-cw (1) 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23 4.49121V10.4912H17",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1 20.4912V14.4912H7",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.51 9.49116C4.01717 8.05795 4.87913 6.77657 6.01547 5.76658C7.1518 4.7566 8.52547 4.05093 10.0083 3.71542C11.4911 3.37992 13.0348 3.42551 14.4952 3.84794C15.9556 4.27037 17.2853 5.05588 18.36 6.13116L23 10.4912M1 14.4912L5.64 18.8512C6.71475 19.9265 8.04437 20.712 9.50481 21.1344C10.9652 21.5568 12.5089 21.6024 13.9917 21.2669C15.4745 20.9314 16.8482 20.2257 17.9845 19.2157C19.1209 18.2058 19.9828 16.9244 20.49 15.4912",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCw);
export default __webpack_public_path__ + "static/media/refresh-cw.56ade1128932010aa900bf66fe2c7b83.svg";
export { ForwardRef as ReactComponent };